<template>
    <v-card class="card_tile" v-if="displayTile && eventSearchObj && ypoSearchText">
        <v-flex class="card_tile__border">
                <span class="ypo-search-title">{{eventTileConstants.TITLE}}</span>
            <v-flex class="ypo-search-open-full-directory">
                <small @click="eventRedirection(eventTileConstants.FULL_EVENT_DIRECTORY)">{{eventTileConstants.FULL_EVENT_DIRECTORY}}</small>
            </v-flex>
            <v-flex>
                <status-overlay content-height="200px" :action="loadingAction"></status-overlay>
                <v-layout v-if="hasSuggestionResults" class="result_block" column>
                    <v-flex @click="openEvent(event)" class="result_block__row" v-for="(event, index) in eventSearchObj.searchResults"
                            :key="index.id">
                        <v-flex class="result_block__row__image">
                            <img class="result_block__row__image__img"
                                 :key="event.eventImageURL"
                                 :src="event.eventImageURL"
                                 :alt="event.eventName"
                                 :onerror="imageErrorFallback(event.fallbackEventImageURL)" />
                        </v-flex>
                        <v-flex xs12 class="result_block__info">
                            <a target="_blank">
                                <p class="result_block__info__eventName">{{event.eventName}}</p>
                            </a>
                            <p class="result_block__info__date">
                                {{ getEventDates(event.startDateTime, event.endDateTime, ' ') }}
                                {{ getYearOfEvent(event.startDateTime, event.endDateTime)}}
                            </p>
                            <small>{{eventLocation(event.city,event.state,event.country,event.locationType)}}</small>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <v-layout class="one-click-search-results" v-if="showFacets && showFacets.length && searchCompleted" column>
                    <v-flex class="one-click-search-results__item" v-for="(facet, index) in showFacets"
                            :key="index">
                        <span v-if="facetOtherLabel(facet, globalSearchConstants.OTHER_LABEL_IN)" class="one-click-search-results__item--other-label">{{facetOtherLabel(facet, globalSearchConstants.OTHER_LABEL_IN)}}&nbsp;</span>
                        <span @click="createAFilterPill(facet)" class="pointer one-click-search-results__item--label"><strong>{{ facet.name }}</strong></span>
                        <span v-if="facetOtherLabel(facet, globalSearchConstants.OTHER_LABEL_BEGINS_WITH)" class="one-click-search-results__item--other-label">&nbsp;{{facetOtherLabel(facet, globalSearchConstants.OTHER_LABEL_BEGINS_WITH)}}</span>
                    </v-flex>
                </v-layout>
                <v-layout v-if="!hasNoResults && searchCompleted" class="ypo-search-all-results">
                    <v-flex class="ypo-search-all-results__block">
                        <span class="ypo-search-all-results__view-all">{{globalSearchConstants.VIEW}} </span>
                        <span class="ypo-search-all-results__all-matching" @click="eventRedirection(globalSearchConstants.ALL_MATCHING_RESULTS)">{{globalSearchConstants.ALL_MATCHING_RESULTS}}</span>
                    </v-flex>
                </v-layout>
                <v-layout v-if="hasNoResults && searchCompleted">
                    <no-results-available :message="globalSearchConstants.NO_EVENT_RESULTS_AVAILABLE"></no-results-available>
                </v-layout>
            </v-flex>
        </v-flex>
    </v-card>
</template>

<script>
    import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
    import { storeAction } from '../../store/storeActions.constant';
    import { storeGetters } from "../../store/storeGetters.constant";
    import {
      eventTileConstants,
      facetLabel,
      globalSearchConstants,
      eventVoucherObject,
      eventNameBeginsPill,
      getAttributionTracking,
    } from "./ypoSearch.constants";
    import { eventDirectoryPageConstant } from "../EventDirectoryPage/eventDirectoryPage.constants";
    import { routerNames } from "../appCommon.constants";
    import { appConstant } from "../../app.constant";
    import { getEventDates, getYearOfEvent } from "../../common/utils/dateTime";
    import { imageErrorFallback } from "../../common/utils/utils";
    import NoResultsAvailable from "./NoResultsAvailable";
    import StatusOverlay from '../StatusOverlay/StatusOverlay';
    import { storeMutation } from "@/store/storeMutations.constant";
    import { gaDataLayerEvent } from '../../plugins/analytics';
    import { gtmEventName } from "@/plugins/gtmAnalytics";


    export default {
        name: 'EventTile',
        data: () => ({
            getEventDates,
            getYearOfEvent,
            globalSearchConstants,
            routerNames,
            eventTileConstants,
            eventNameBeginsPill,
            eventVoucherObject,
            defaultFilterKey: eventDirectoryPageConstant.constant.myChapterDefaultFilter.parentKey,
            displayTile: true,
            appConstant,
        }),
        props: {
            eventSearchObj: {
                required: true,
                type: Object,
            },
            ypoSearchText: {
                type: String,
                required: true,
            },
            postSelectCallback: {
                type: Function,
                required: true,
            },
            showVoucherOneClick: {
                type: Boolean,
                required: true,
            },
            searchCompleted: {
                type: Boolean,
                required: true,
            },
        },
        components: {
          NoResultsAvailable,
          StatusOverlay,
        },
        methods: {
            ...mapActions({
                getEventSearchSuggestions: `ypoSearch/${storeAction.getEventSearchSuggestions}`,
                initiateTracking: `ypoSearch/${storeAction.initiateTracking}`,
            }),
            ...mapMutations({
                setEventSelectedLetterFilter: `eventDirectory/${storeMutation.setEventSelectedLetterFilter}`,
            }),
            facetLabel,
            createAFilterPill(facet) {
                if (this.postSelectCallback) this.postSelectCallback();
                const trackingObject = {
                    committedSearchTerm: this.ypoSearchText,
                    oneClickSearchText: this.showFacets ? facet.name : null,
                    oneClickSearchType: globalSearchConstants.EVENT,
                };

                sessionStorage.removeItem(appConstant.storageKeys.eventDirectoryStoredFilters);
                this.setEventSelectedLetterFilter();
                const excludeOtherChaptersEvents = eventDirectoryPageConstant.constant.myChapterDefaultFilter.filter;

                if (facet.name === globalSearchConstants.WHO_CAN_ATTEND) {
                    const pillFilter = [...facet.filters];
                    sessionStorage.removeItem(appConstant.storageKeys.eventDirectoryStoredFilters);
                    this.$router.push({
                        path: `/${routerNames.EVENT_DIRECTORY_PAGE}`,
                        query: {
                            eventFilters: JSON.stringify({
                                whoCanAttend: pillFilter,
                                sponsors: [excludeOtherChaptersEvents],
                            }),
                        },
                    });
            } else if (facet.filterKey === eventTileConstants.ACCEPTS_VOUCHER) {
                  const pillFilter = [facet];
                    sessionStorage.removeItem(appConstant.storageKeys.eventDirectoryStoredFilters);
                    this.$router.push({
                        path: `/${routerNames.EVENT_DIRECTORY_PAGE}`,
                        query: {
                            eventFilters: JSON.stringify({
                                acceptsVoucher: pillFilter,
                                sponsors: [excludeOtherChaptersEvents],
                            }),
                        },
                    });
                } else {
                    const {
                        filterKey,
                        ribbonGroupName,
                    } = facet.filters[0];

                    const {
                        key,
                        name,
                        fieldToQuery,
                        integratedSearchName,
                    } = facet;

                    if ((facet.name === globalSearchConstants.MY_CHAPTER_EVENTS) || (facet.name === globalSearchConstants.MY_NETWORK_EVENTS)) {
                        const eventNameFilter = eventNameBeginsPill(this.ypoSearchText);
                        const pillFilter = {
                            ...facet.filters[0],
                            name,
                            integratedSearchName,
                            key,
                            fieldToQuery,
                            ribbonGroupName,
                            filterKey,
                        };
                        sessionStorage.removeItem(appConstant.storageKeys.eventDirectoryStoredFilters);
                        this.$router.push({
                            path: `/${routerNames.EVENT_DIRECTORY_PAGE}`,
                            query: {
                                eventFilters: JSON.stringify({
                                    searchFilters: [eventNameFilter],
                                    sponsors: [pillFilter],
                                }),
                                eventSearchText: this.ypoSearchText ? this.ypoSearchText : "",
                            },
                        });
                    } else {
                        const pillFilter = {
                            ...facet.filters[0],
                            name,
                            integratedSearchName,
                            key,
                            fieldToQuery,
                            ribbonGroupName,
                            filterKey,
                            label: this.facetLabel(facet.name, facet.integratedSearchName, this.ypoSearchText),
                        };
                        sessionStorage.removeItem(appConstant.storageKeys.eventDirectoryStoredFilters);
                        this.$router.push({
                            path: `/${routerNames.EVENT_DIRECTORY_PAGE}`,
                            query: {
                                eventFilters: JSON.stringify({
                                    searchFilters: [pillFilter],
                                    sponsors: [excludeOtherChaptersEvents],
                                }),
                                eventSearchText: this.ypoSearchText ? this.ypoSearchText : "",
                            },
                        });
                    }
                }
                this.initiateTracking(trackingObject);
            },
            openEvent(event) {
                if (this.postSelectCallback) this.postSelectCallback();
                const trackingObject = {
                    committedSearchTerm: this.ypoSearchText,
                    tileText: this.hasSuggestionResults ? event.eventName : null,
                    tileType: globalSearchConstants.EVENT,
                };
                if (event.eventUrl) {
                  const url = getAttributionTracking(event.eventUrl, eventTileConstants.ATTRIBUTION_TRACKING.searchResultTileId);
                    window.open(url, this.linkTarget);
                }
                this.initiateTracking(trackingObject);
            },
            eventLocation(city, state, country, locationType) {    
                let location = city || '';                
                if (city && (state || country)) location = `${location},`;
                if (state && country) {
                    location = `${location} ${state}, ${country}`;
                } else if (state) {
                    location = `${location} ${state}`;
                } else if (country) {
                    location = `${location} ${country}`;
                }
                location = location.trim();
                if (locationType && locationType.includes(eventTileConstants.VIRTUAL)) {
                    return location
                        ? `${location} + ${eventTileConstants.VIRTUAL}`
                            : eventTileConstants.VIRTUAL;
                }
                return location;
            },
            imageErrorFallback,
            facetOtherLabel(facet, expectedLabel) {
                return facet.integratedSearchName === expectedLabel ? expectedLabel : "";
            },
            eventRedirection(to) {
                if (this.postSelectCallback) this.postSelectCallback();
                sessionStorage.removeItem(appConstant.storageKeys.eventDirectoryStoredFilters);
                this.setEventSelectedLetterFilter();

                if (to === globalSearchConstants.ALL_MATCHING_RESULTS) {
                    const trackingObject = {
                        committedSearchTerm: this.ypoSearchText,
                        oneClickSearchText: globalSearchConstants.ALL_MATCHING_RESULTS,
                        oneClickSearchType: globalSearchConstants.EVENT,
                    };
                    this.$router.push({
                        path: `/${routerNames.YPO_EVENTS}`,
                        query: {
                            eventSearchText: this.ypoSearchText ? this.ypoSearchText : '',
                        },
                    });
                    this.initiateTracking(trackingObject);
                    gaDataLayerEvent(gtmEventName.C_Event_Search_Trigger, globalSearchConstants.ALL_MATCHING_RESULTS);
                } else if (to === eventTileConstants.FULL_EVENT_DIRECTORY) {
                    const trackingObject = {
                        committedSearchTerm: this.ypoSearchText,
                        oneClickSearchText: eventTileConstants.FULL_EVENT_DIRECTORY,
                        oneClickSearchType: globalSearchConstants.EVENT,
                    };
                    this.$router.push({
                        path: `/${routerNames.EVENT_DIRECTORY}`,
                    });
                    this.initiateTracking(trackingObject);
                    gaDataLayerEvent(gtmEventName.C_Event_Search_Trigger, eventTileConstants.FULL_EVENT_DIRECTORY);
                }
            },
        },
        computed: {
            ...mapState('actionState', ['actions']),
            ...mapGetters({
                isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
            }),
            loadingAction() {
                return this.actions[storeAction.getEventSearchSuggestions];
            },
            hasSuggestionResults() {
                return this.eventSearchObj &&
                       this.eventSearchObj.searchResults &&
                       this.eventSearchObj.searchResults.length > 0;
            },
            showFacets() {
                let facets = [];
                const hasValidEventResults =
                    this.eventSearchObj &&
                    this.eventSearchObj.searchResults &&
                    this.eventSearchObj.searchResults.length > 0;
                const hasValidEventRibbonGroup =
                    this.eventSearchObj.searchRibbonGroup &&
                    this.eventSearchObj.searchRibbonGroup.length > 1;
                if (!hasValidEventResults && !hasValidEventRibbonGroup && this.showVoucherOneClick) {
                    const ribbonSearch = this.eventSearchObj &&
                        this.eventSearchObj.searchRibbonGroup &&
                        this.eventSearchObj.searchRibbonGroup.slice(1, 1);
                    facets = { ...ribbonSearch, eventVoucherObject };
                } else if (hasValidEventResults && hasValidEventRibbonGroup && this.showVoucherOneClick) {
                    facets = { ...this.eventSearchObj.searchRibbonGroup, eventVoucherObject };
                }
                if (hasValidEventResults && hasValidEventRibbonGroup && !this.showVoucherOneClick) {
                        facets = { ...this.eventSearchObj.searchRibbonGroup };
                    }
                return facets;
            },
            hasNoResults() {
                return this.eventSearchObj &&
                    this.eventSearchObj.searchResults &&
                    this.eventSearchObj.searchResults.length <= 0
                    && this.showFacets.length <= 1;
            },
            linkTarget() {
                return this.isMobileAppBrowser ? '_self' : '_blank';
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .card_tile {
        text-align: left !important;
        padding: 20px 0 20px 20px;
        box-shadow: none;
        height: 100vh;

        @include breakpoint(md){
            height: unset !important;
        }

        @include breakpoint(xs) {
            border-top: 4px solid $ypo-tile-border;
        }

        &__border {
            height: 100vh;
            border-right: 1px solid $ypo-tile-border;
            @include breakpoint(xs) {
                border-right: none;

            }
            @include breakpoint(sm) {
                height: unset !important;
            }
        }
    }

    .divider {
        color: $black;
        font-weight: 500;
    }

    .one-click-search-results {
        flex-direction: column;
        @include breakpoint(sm) {
            flex-direction: row;
            flex-wrap: wrap;
        }

        &__item {
            @include breakpoint(sm) {
                border: 1px solid $ypo-cta;
                box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.2);
                margin: 6px 3px;
                padding: 6px;
                max-width: fit-content !important;
                height: 36px;
            }
            padding: 6px 15px 6px 0;
            font-family: 'Raleway', sans-serif;

            &--other-label {
                color: $black;
                font-size: 12px;
                font-family: "Noto Sans", sans-serif;
            }

            &--label {
                font-size: 14px;
                color: $ypo-cta;
                text-decoration: none;
            }
        }
    }

    .result_block {
        position: relative;
        border-bottom: 1px solid $ypo-tile-border;
        margin-right: 20px;
        margin-bottom: 10px;

        &__row {
            position: relative;
            padding-left: 60px;
            margin-bottom: 10px;
            min-height: 70px;
            align-items: center;
            display: inherit;
            transition: 0.3ms all ease;
            cursor: pointer;

            &:hover {
                background: $ypo-extra-light-gray;
            }

            &__image {
                position: absolute;
                left: 0;

                &__img {
                    height: 48px;
                    width: 48px;
                    border-radius: 20%;
                    overflow: hidden;
                    display: block;
                    font-size: 8px;
                }
            }
        }

        &__info {

            &__eventName {
                display: block;
                display: -webkit-box;
                color: $ypo-cta;
                font-size: 14px;
                margin: 0;
                font-weight: bold;
                font-family: 'Raleway', sans-serif;
                letter-spacing: 0.22px;
                line-height: 20px;
                text-overflow: ellipsis;
                overflow: hidden;
                cursor: pointer;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;

            }

            &__date {
                font-weight: bold !important;
                color: $ypo-dark-gray !important;
                font-size: 12px !important;
                margin: 0;
                line-height: 16px;
                font-family: 'Noto Sans', sans-serif;
            }

            a {
                text-decoration: none;
            }


            small {
                display: block;
                color: $black;
                font-size: 12px;
                letter-spacing: -0.1px;
                line-height: 16px;
                text-overflow: ellipsis;
                overflow: hidden;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                display: -webkit-box;
                cursor: pointer;
                font-family: 'Noto Sans', sans-serif;
            }

        }
    }

</style>
